import React from 'react';
import './ConfirmModal.css';

/**
 * ConfirmModal Component
 * 
 * A reusable confirmation modal for critical operations
 */
const ConfirmModal = ({ isOpen, onClose, onConfirm, title, message, confirmText = 'Confirm', cancelText = 'Cancel', variant = 'default' }) => {
  if (!isOpen) return null;

  const variantStyles = {
    default: {
      icon: '⚠️',
      confirmButtonClass: 'confirm-modal-btn confirm-modal-btn-primary',
      borderColor: '#E5E7EB'
    },
    danger: {
      icon: '⚠️',
      confirmButtonClass: 'confirm-modal-btn confirm-modal-btn-danger',
      borderColor: '#EF4444'
    },
    warning: {
      icon: '⚠️',
      confirmButtonClass: 'confirm-modal-btn confirm-modal-btn-warning',
      borderColor: '#F59E0B'
    }
  };

  const style = variantStyles[variant] || variantStyles.default;

  return (
    <div className="confirm-modal-overlay" onClick={onClose}>
      <div className="confirm-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="confirm-modal-header" style={{ borderBottomColor: style.borderColor }}>
          <h3 className="confirm-modal-title">{title}</h3>
        </div>
        <div className="confirm-modal-body">
          <p className="confirm-modal-message">{message}</p>
        </div>
        <div className="confirm-modal-footer">
          <button
            type="button"
            className="confirm-modal-btn confirm-modal-btn-secondary"
            onClick={onClose}
          >
            {cancelText}
          </button>
          <button
            type="button"
            className={style.confirmButtonClass}
            onClick={() => {
              onConfirm();
              onClose();
            }}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;


